<template>
  <div class="signup-loader">
    <canvas class="signup-loader__canvas" ref="loader"></canvas>
    <p class="signup-loader__text">
      Please wait while we are evaluating your credit worthiness, this may take upto a {{initialTime}} seconds.
      <br />Be patient, Fortune favours the bold !
    </p>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ActionButton from "../components/ActionButton";

export default {
  name: "Signup-Loader",
  data() {
    return {
      context: null,
      canvas: null,
      radius: 90,
      divisor: 0,
      initialTime: 0,
      interval: undefined
    };
  },
  components: { ActionButton },
  computed: {
    ...mapGetters(["waitTime", "waitMessage"])
  },
  mounted() {
    this.divisor = this.waitTime / 2;
    this.context = this.$refs["loader"].getContext("2d");
    this.canvas = this.$refs["loader"];
    this.canvas.width = 180;
    this.canvas.height = 180;
    this.animate();
    this.initialTime = this.waitTime;
    this.poll(90000, 10000)
      .then(response => {
        this.$store.dispatch("storeMixpanelEvent", {
          eventName: "LOGGED_IN",
          propertyName: "REGISTRATION_STATUS",
          propertyValue: "SIGNUP"
        });
        if (response.creditLimit > 0) {
          window.clearInterval(this.interval);
          this.$router.push({ name: "Success" });
        } else {
          window.clearInterval(this.interval);
          this.$router.push({ name: "Failure" });
        }
      })
      .catch(() => {
        window.clearInterval(this.interval);
        this.$router.push({ name: "Pending" });
      });
    this.$store.dispatch("storeMixpanelEvent", {
      eventName: "SCREEN",
      propertyName: "SCREEN_NAME",
      propertyValue: "NBFC_LOADER"
    });
  },
  created() {
    history.pushState(null, null, document.URL);
    window.addEventListener("popstate", () => {
      history.pushState(null, null, document.URL);
    });
  },

  methods: {
    moveClock() {
      this.context.beginPath();
      this.context.globalCompositeOperation = "source-over";
      this.context.font = this.radius + "px Arial";
      this.context.textAlign = "center";
      this.context.textBaseline = "middle";
      this.context.fillStyle = "white";
      this.context.fillText(this.initialTime - this.waitTime, 90, 90);
      this.context.globalCompositeOperation = "destination-over";
      this.context.lineWidth = 5;
      this.context.fill();
      this.context.fillStyle = "#468eff";
      this.context.strokeStyle = "#468eff";
      this.context.arc(
        90,
        90,
        this.radius,
        Math.PI * 1.5,
        (360 * Math.PI) / 180 -
          Math.PI * ((this.waitTime - 1) / this.divisor) +
          Math.PI * 1.5,
        true
      );
      this.context.lineTo(90, 90);
      this.context.fill();
      this.context.closePath();
    },
    animate() {
      this.interval = setInterval(() => {
        this.$store.dispatch(
          "setWaitTime",
          this.waitTime < 1 ? this.divisor * 2 : this.waitTime - 1
        );
        this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.moveClock();
      }, 1000);
    },
    poll(timeout, interval = 100) {
      let endTime = Number(new Date()) + (timeout || 2000);
      let checkCondition = (resolve, reject) => {
        this.$store
          .dispatch("signup_status")
          .then(response => {
            if (response.userSignupStatus === "PROFILE_COMPLETE") {
              resolve(response);
            } else if (Number(new Date()) < endTime) {
              setTimeout(checkCondition, interval, resolve, reject);
            } else {
              reject(
                new Error({
                  message: "Not able to generate response in given timeframe"
                })
              );
            }
          })
          .catch(err => reject(err));
      };
      return new Promise(checkCondition);
    }
  }
};
</script>
<style lang="scss" scoped>
.signup-loader {
  display: grid;
  justify-content: center;
  align-items: center;
  justify-items: center;
  position: absolute;
  z-index: 9999999;
  position: fixed;
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
  background: var(--primary-color);
  &__text {
    font-size: 2rem;
    line-height: 1.57;
    color: var(--white);
    text-align: center;
    @media only screen and (min-width: 640px) {
      font-size: 2.4rem;
    }
  }
  &__canvas {
    background: #80b4f8;
    border-radius: 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SignupLoader.vue